import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../_services/authentication.service';
import { Meta, Title } from "@angular/platform-browser";
import storage from 'local-storage-fallback';
import { Globals }              from '../../Globals';

@Component({
  selector: 'auth-password',
  templateUrl: './request-password.component.html'
})

export class PasswordRequestComponent implements OnInit {
	model: any = {};
  error;
  loading = false;
  resetLoading = false;
  requestStatus;
  resetStatus;
  constructor(private globals: Globals, private meta: Meta, private title: Title, private router: Router, private authenticationService: AuthenticationService) { }
	ngOnInit() {
    this.title.setTitle("Request new password");
    if(this.authenticationService.isLoged()) this.router.navigate(['/']);
  }

  requestPassword() {
    if(this.loading) return;
    this.loading = true;
    this.requestStatus= null;
    this.authenticationService.requestPassword(this.model.email).subscribe(result => {
      this.requestStatus = result;
      this.loading = false;
      this.requestStatus.code === 200 ? this.model.token = this.requestStatus.token : false;
    });
  }
  resetPassword(){
    if(this.resetLoading) return;
    this.resetLoading = true;
    this.resetStatus = null;
    this.authenticationService.resetPassword(this.model.token, this.model).subscribe(result => {
      this.resetStatus = result;
      if(this.resetStatus.code === 200){
        storage.setItem('token', this.resetStatus.data.user.token);
        this.globals.user = this.resetStatus.data.user;
        this.globals.token = this.resetStatus.data.user.token;
        this.router.navigate(['/mycourse']);
      }
      this.resetLoading = false;
    });
  }
}
